import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  @ViewChild('video', {static: true}) video: HTMLVideoElement;

  isMobile = false
  bannerHome: string;
  bannerHomeMobile: string;
  $breakpoint: Subscription;

  constructor(
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnDestroy(): void {
    this.$breakpoint.unsubscribe();
  }

  ngOnInit(): void {
    sessionStorage.clear();
    localStorage.clear();

    this.$breakpoint = this.breakpointObserver.observe(['(max-width:935px)']).subscribe(res => {
      if(res.matches){
        this.isMobile = true
      }
    });
  }

}
